import { HTMLMotionProps, motion } from 'framer-motion'

type FadeInProps = {
	children: React.ReactNode
	variant: 'in' | 'out'
	className?: string
	onView?: boolean
} & HTMLMotionProps<'div'>

export function Fade({ children, onView = true, transition, variant, ...props }: FadeInProps) {
	const animate = variant === 'in' ? { opacity: 1 } : { opacity: 0 }

	return (
		<motion.div
			initial={{ opacity: variant === 'in' ? 0 : 1 }}
			transition={{ duration: 1.5, ...transition }}
			{...(onView ? { whileInView: animate } : { animate })}
			viewport={{ once: onView }}
			style={{ willChange: 'opacity' }}
			{...props}
		>
			{children}
		</motion.div>
	)
}
